module.exports = __webpack_public_path__ + "img/finances-bg-8coin.4460e373.png";